import type { ManageAPI } from "~/manage-api/types";
import { anyMatch } from "~/util/store";

const NDASH = '–';

export function getAllFloors(stores: Array<ManageAPI.Store>): Array<ManageAPI.FloorBase> {
    let t = stores
        .filter((store: ManageAPI.Store) => store.hasOwnProperty("floor"))
        .map((store: ManageAPI.Store) => store.floor);

    return [
        ...new Map(
            t.map((floor: ManageAPI.FloorBase) => [floor["id"], floor])
        ).values(),
    ].sort((a: ManageAPI.FloorBase, b: ManageAPI.FloorBase) =>
        a.description.localeCompare(b.description, undefined, {
            numeric: true,
            sensitivity: "base",
        })
    );
}

export function getAllFOBs(stores: Array<ManageAPI.Store>): number[] {
    let t = stores
        .filter((store: ManageAPI.Store) => store.hasOwnProperty("fieldOfBusinessId"))
        .map((store: ManageAPI.Store) => store.fieldOfBusinessId);
    return t.filter((element: number, index: number) => {
        return t.indexOf(element) === index;
    })
}

/**
 * @deprecated Use instead `todaysOpeningHoursItem` from `utils/date-n-time`.
 */
export function today(store: ManageAPI.Store | undefined, T: { (key: string): string, (template: TemplateStringsArray): string }) {
    if (!store) return ""
    if (store?.unformattedOpeningHours.length == 0) return ""
    var d = new Date();
    var n = d.getDay();
    var resultObject: any = {};
    let year = d.getFullYear()
    let month = (d.getMonth() + 1).toString().padStart(2, "0");
    let date = d.getDate().toString().padStart(2, "0");
    let td = year + '-' + month + '-' + date //YYYY-MM-DD
    if (store.exceptionalOpeningHours) {
        for (var i = 0; i < store.exceptionalOpeningHours.length; i++) {
            const { date } = store.exceptionalOpeningHours[i]
            if (td == date) {
                const { fromHour, fromMinute, toMinute, toHour } = store.exceptionalOpeningHours[i]
                if (fromHour == 0 && fromMinute == 0 && toHour == 0 && toMinute == 0) {
                    return T`closed`
                } else {
                    return (fromHour + (fromMinute == 0 ? "" : "." + fromMinute) + "–" + toHour + (toMinute == 0 ? "" : "." + toMinute));
                }
            }
        }
    }

    for (var i = 0; i < store.unformattedOpeningHours.length; i++) {
        const { openingStatus, days } = store.unformattedOpeningHours[i]
        if (
            days.includes(String(n)) && openingStatus == "OPEN"
        ) {
            resultObject = store.unformattedOpeningHours[i];
        } else if (
            days.includes(String(n)) && (openingStatus == "CLOSED" || openingStatus == 'BY_APPOINTMENT')
        ) {
            if (openingStatus == 'CLOSED')
                return T`closed`
            else if (openingStatus == 'BY_APPOINTMENT')
                return T`by appointment`

        }

    }

    if (!resultObject) {
        return ""; // in case shopping center is closed as well
    } else {
        if (resultObject.hasOwnProperty("dailyOpeningHours")) {
            var result =
                resultObject["dailyOpeningHours"][0].from.replace(":00", "") +
                NDASH +
                resultObject["dailyOpeningHours"][0].to.replace(":00", "");
            return result.replace(/:/g, ".");
        }
        return ""
    }
}

export function filterStores(
    stores: readonly ManageAPI.Store[],
    term: string,
    by_floor: string,
    by_fob: string
): ManageAPI.Store[] {

    term = term.toLowerCase();
    const floor_id = parseInt(by_floor);
    const fob_id = parseInt(by_fob);

    return stores.reduce((acc: ManageAPI.Store[], store) => {
        const _name = store.name.toLowerCase();
        const _floors = [store.floor?.id, store.secondaryFloor?.id];
        const _fob = store.fieldOfBusinessId;

        if (term && !_name.includes(term)) return acc;
        if (by_floor && !_floors.includes(floor_id)) return acc;
        if (by_fob && _fob != fob_id) return acc;

        acc.push(store);

        return acc;
    }, []);
}

export function parseDateFromString(params: string) {
    const [date, month, year] = params.split(".");
    const event = new Date();
    event.setDate(Number(date));
    event.setMonth(Number(month) - 1);
    event.setFullYear(Number(year));
    return event;
}

export function getTodayString(): string {
    let today =
        new Date().getDate() +
        "." +
        (new Date().getMonth() + 1) +
        "." +
        new Date().getFullYear();
    return today
}
export function availableLunchDays(lunch: ManageAPI.Lunch[]) {
    const today = new Date();
    const day =
        today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();
    const availableLunchDays = [day];

    lunch.forEach((item) =>
        item.dailyLunchMenus.forEach((i) => {
            if (!availableLunchDays.includes(i.day)) {
                availableLunchDays.push(i.day);
            }
        })
    );

    return availableLunchDays.sort((a, b) =>
        parseDateFromString(a).valueOf() - parseDateFromString(b).valueOf()
    );
}

export function getDay(params: string) {
    if (!params) return ""
    
    // Parse the date in format DD.MM.YYYY
    const [day, month, year] = params.split(".");
    
    if (!day || !month || !year) {
        return "";
    }
    
    // Create a new Date with no time component
    const date = new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day)
    );
    
    // Return the day of week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    return date.getDay();
}
export function getFobs(siteGroupings:SiteGroupings | undefined, isRestaurant: boolean, stores: readonly ManageAPI.Store[],  filterOutEmpty?:boolean, scdata?:ManageAPI.ShoppingCenterData ) {
    let fieldsOfBusiness: ManageAPI.Fob[] | Grouping[] = [];
    let fobsByGrouping = false;
    if(siteGroupings?.lineOfBusiness.length && !isRestaurant) {
        let newCat =  undefined;
        fobsByGrouping = true;
        //Filtering out pages that won't have any results in that fob
        fieldsOfBusiness = filterOutEmpty? siteGroupings?.lineOfBusiness.filter(
            anyMatch(stores)
        ): siteGroupings?.lineOfBusiness.filter(el => el.type == 'lineOfBusiness');
        if(siteGroupings?.store?.length){
            newCat = siteGroupings?.store.find(item => item.name.includes('-fob'));
            if (newCat) fieldsOfBusiness.push(newCat);
        }       
        return {fieldsOfBusiness, fobsByGrouping};   
    }
    else if (siteGroupings?.store?.length && isRestaurant) {
        fobsByGrouping = true;
        fieldsOfBusiness = siteGroupings?.store.filter(item => !item.name.includes('-fob'));
        return {fieldsOfBusiness, fobsByGrouping};
    } else {
        fieldsOfBusiness = scdata?.fieldsOfBusiness?.filter( 
            anyMatch(stores)
        ) || [];
        return {fieldsOfBusiness, fobsByGrouping};
    }
}
export function findFobByQuery(query:string, fobs:ManageAPI.Fob[] | Grouping[]) {
    let foundFob;
    let fobNumber=parseInt(query);
    if(isNaN(fobNumber)){
        foundFob = fobs.find(o => 'name' in o && o.name.toLowerCase() === query.toLowerCase());
    } else  {
        foundFob = fobs.find(o => 'id' in o && o.id === fobNumber);
    }
    return foundFob;  
}

/**
 * Converts a 24-hour time string (HH:MM) to a readable format (HH.MM)
 * @param time Time string in format "HH:MM"
 * @returns Formatted time string
 */
export function convertTimeToReadable(time: string): string {
    if (!time) return '';
    return time.replace(':', '.');
}